import { Button, Modal } from "antd";
import React, { useState } from "react";
import "./TaksGuideModal.less";

export const TaksGuideModal = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <>
      <Button
        // size="small"
        className="taskGuidBtn"
        type="primary"
        shape="round"
        onClick={showModal}
      >
        Task Guide
      </Button>

      <Modal
        title="Task guide list"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={null}
        footer={null}
        width={700}
      >
        <ul className="pl-3 mb-3 taskGuideLst">
          {/* <li>
            For Time Sensitive Tasks-Notifications will be sent after 15 mins of
            shift start time.
          </li>
          <li>For Reminders - Will be send randomly.</li>
          <li>
            For During the day tasks - Notifications will be sent when 40% of
            the day/shift is completed and 90% of the day/shift is completed.
          </li>
          <li>
            For End of the day tasks - Notifications will be sent before half an
            hour of the day/shift completion time.
          </li>
          <li>You can add only 100 custom tasks per employee, as of now.</li> */}
          <li>
            If you assign an End of the day task and if 90% of today's shift is
            pending for the employee, it will be assigned today otherwise next
            day. Notifications will be sent before half an hour of the day/shift
            completion time.
          </li>
          <li>
            If you assign a During Day task and if 40% of today's shift is
            pending for the employee, it will be assigned today otherwise next
            day. Notifications will be sent when 40% of the day/shift is
            completed and 90% of the day/shift is completed
          </li>
          <li>
            If you assign a Time Sensitive task and if 15% of today's shift is
            pending for the employee, it will be assigned today otherwise next
            day. Notifications will be sent after 15 mins of shift start time.
          </li>
          <li>
            If you assign a Reminder task and if 10% of today's shift is pending
            for the employee, it will be assigned today otherwise next day.
            Notifications will be send randomly.
          </li>
          <li>
            You can add only 100 custom tasks per employee, as of now in the
            free plan.
          </li>
        </ul>
        <div className="d-flex justify-content-center">
          <Button type="primary" shape="round" onClick={handleOk}>
            OK
          </Button>
        </div>
      </Modal>
      {/* <Tooltip
          trigger={["hover"]}
          placement="topLeft"
          overlayClassName="numeric-input task-detail-tooltip"
          arrowPointAtCenter
          title={() => {
            return (
              <span>
                - For Time Sensitive Tasks-Notifications will be sent after 15 mins of shift start time.
                - For Reminders - Will be send randomly.
                - For During the day tasks - Notifications will be sent when 40% of the day/shift is completed and 90% of the day/shift is completed.
                - For End of the day tasks - Notifications will be sent before half an hour of the day/shift completion time.
                - You can add only 5 custom tasks per employee, as of now.
              </span>
            );
          }}
        >
          <div className="stRight">
            <CustIcon type="info" className="ml-2" />
          </div>
        </Tooltip> */}
    </>
  );
};
